export default __webpack_public_path__ + "static/media/Nisa_Amoils_AHV_In_Moms_We_Trust.253e8793.jpg";